// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

function setProductPriceAsVariant(product, is_cents){
    for (const option of product.options_with_values) {
        if(option.name === 'price_sq-ft') {
            let [{title: price}] = option.values

            if(is_cents)
                price *= 100

            product.price_min = parseFloat(price)
            product.price_max = parseFloat(price)
        }
    }
    return product;
}

function setProductsPriceAsVariant(json) {
    json.products = json.products.map(function(product) {
        return setProductPriceAsVariant(product);
    })
    return json;
}

//Overwrite
function BCSfSuggestionCallback(json) {
    json = setProductsPriceAsVariant(json)
    var filter = bcsffilter,
        cache = filter.suggestionCache;

    if (json.hasOwnProperty("prev_query")) {
        var prev_query = json.prev_query;
        if (cache.hasOwnProperty(prev_query)) {
            var e,
                f = cache[prev_query],
                g = ["collections", "did_you_mean", "pages", "suggestions", "suggest_query"],
                h = g.length;

            for (e = 0; e < h; e++)
                json[g[e]] = getValueInObjectArray(g[e], f);

            json.prev_total_product = getValueInObjectArray("total_product", f);

            f[filter.findIndexArray("products", f, "key")].values = json.products;
            f.push({
                key: "local_cache",
                values: !0
            });
            f.push({
                key: "suggest_total_product",
                values: json.total_product
            })
            filter.suggestionCache[prev_query] = f
        }
    }
    suggestionCallback(jQ.map(json, function (json, filter) {
        return {key: filter, values: json}
    }))
}